// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'


// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-default/index.css'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
require('../css/conmon.css')
require('../css/swiper.min.css')
require('../js/swiper.min.js')
require('../js/jquery.js')
import VideoPlayer from 'vue-video-player'
Vue.use(VideoPlayer);
// Vue.use(ElementUI);
import axios from 'axios';
axios.defaults.withCredentials = true;
Vue.prototype.axios = axios.create({ 
	 baseURL: '',//测试地此

	 transformRequest: [function(data) {
		  var qs = require('qs');
		  //return data;
		  return qs.stringify(data);
	 }],
	 headers: {
	  'content-type': 'application/x-www-form-urlencoded; charset=utf-8',
	//   'Access-Control-Allow-Origin':'*'
	 },
	 params: {
	  

	 },
	 timeout: 20000,
	 responseType: 'json', // default
});
Vue.config.productionTip = true

/* eslint-disable no-new */
// window.apiready = function(){
	
// }
new Vue({
	  el: '#app',
	  router,
	  template: '<App/>',
	  components: { App }
	})



// WEBPACK FOOTER //
// ./src/main.js